import CurrencyDetail from './CurrencyDetail';

export default CurrencyDetail;
